import { useContext } from 'react'
import { Context } from '../contexts/AppState'

function useWalletModal () {
  const { walletModal, setWalletModal } = useContext(Context)
  return { walletModal, setWalletModal }
}

export default useWalletModal
